import { Component, Input } from '@angular/core';
import { ServiceTechnologyProvidersTableSection } from 'src/app/model/section/service-technology-providers-table-section';

import { documentToHtmlString } from '.';

@Component({
  selector: 'app-service-technology-providers-table-section',
  templateUrl: './service-technology-providers-table-section.component.html',
  styleUrls: ['./service-technology-providers-table-section.component.scss']
})
export class ServiceTechnologyProvidersTableSectionComponent {
  @Input() tableSections: ServiceTechnologyProvidersTableSection[] = [];
  constructor() {}
  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }
    return documentToHtmlString(richText);
  }
}
